export var deriveBudgetRequestState = function (arrangementsData) {
    if (!(arrangementsData === null || arrangementsData === void 0 ? void 0 : arrangementsData.arrangements)) {
        return {
            budgetRequests: [],
            pendingBudgetRequests: [],
        };
    }
    var arrangements = arrangementsData.arrangements;
    var budgetRequests = arrangements.filter(function (a) { return a.arrangement_type === 'budget_request'; });
    var paymentAuthorizations = arrangements.filter(function (a) { return a.arrangement_type === 'payment_authorization'; });
    var authorizedBudgetRequestIds = new Set(paymentAuthorizations
        .map(function (a) { return a.budget_request_id; })
        .filter(function (id) { return typeof id === 'number'; }));
    var pendingBudgetRequests = budgetRequests.filter(function (br) { return !authorizedBudgetRequestIds.has(br.id); });
    return {
        budgetRequests: budgetRequests,
        pendingBudgetRequests: pendingBudgetRequests,
    };
};
